module.exports = __webpack_public_path__ + "assets/img/restock.dd03ad22.png";